import { useState } from "react";
import { discussions } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

export default function Discussions() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="discussions" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="05"
          title="剧迷热评 · 聊聊看点"
          subtitle="来自影迷的真实观后感，追片前先听听大家怎么说"
          actionLabel="进入评论区"
          actionHref="#discussions"
        />

        <div className="grid gap-4 md:grid-cols-2 md:gap-5">
          {discussions.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.user} 的用户头像`}
                    title={`${item.user} 的剧评`}
                    className="h-full w-full object-cover"
                  />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="truncate text-sm font-medium text-foreground-950">
                      {item.user}
                    </span>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {item.role}
                    </span>
                  </div>
                  <span className="block text-xs text-foreground-500">{item.time}</span>
                </div>
                <a
                  href="#discussions"
                  className="shrink-0 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] text-accent-900"
                >
                  #{item.show}
                </a>
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.content}</p>

              <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <button
                  type="button"
                  onClick={() => toggleLike(item.id)}
                  className={`flex cursor-pointer items-center gap-1.5 transition-colors ${
                    liked[item.id] ? "text-primary-600" : "hover:text-primary-600"
                  }`}
                >
                  <i className={liked[item.id] ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
                  {item.likes}
                </button>
                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600"
                >
                  <i className="ri-chat-1-line"></i>
                  {item.replies}
                </button>
                <button
                  type="button"
                  className="ml-auto flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600"
                >
                  <i className="ri-share-forward-line"></i>
                  分享
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}